// src/services/sectors.ts
import { apiJson } from './http';

export type SectorDTO = {
  id: number;
  name: string;
  icon?: string | null;
  active: boolean;
};

export type CreateSectorRequest = {
  name: string;
  icon?: string | null;
  active?: boolean;
};

// helper per normalizzare risposta array/page
function toArray<T>(res: any): T[] {
  if (Array.isArray(res)) return res as T[];
  if (res && Array.isArray(res.content)) return res.content as T[];
  return [];
}

export async function listSectors(active?: boolean): Promise<SectorDTO[]> {
  const q = active === undefined ? '' : `?active=${active}`;
  const res = await apiJson<any>(`/p/sectors${q}`);
  return toArray<SectorDTO>(res);
}

export async function getSector(id: number): Promise<SectorDTO> {
  return apiJson<SectorDTO>(`/p/sectors/${id}`);
}

export async function createSector(payload: CreateSectorRequest): Promise<SectorDTO> {
  return apiJson<SectorDTO>('/p/sectors', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function updateSector(id: number, payload: Partial<CreateSectorRequest>): Promise<SectorDTO> {
  return apiJson<SectorDTO>(`/p/sectors/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}

export async function deleteSector(id: number): Promise<void> {
  await apiJson<void>(`/p/sectors/${id}`, { method: 'DELETE' });
}
